module.exports = __webpack_public_path__ + "static/media/Call bell.95ab065f.png";